import React from 'react';
import TablaEstadoCuentaProduc from '../components/impuestoprodu/tablaEstadoCuenta';

function estadoCuentaProduc() {
  return (
      <div className='col-12 d-flex justify-content-center row p-0 m-0'>
        <TablaEstadoCuentaProduc />
      </div>
  );
}

export default estadoCuentaProduc;




// WEBPACK FOOTER //
// ./src/pages/estadocuentaproduc.js